import React from 'react';
import { useLocation } from 'react-router-dom';
import FieldPageChrome from '../../components/field/FieldPageChrome';
import { PageHeaderBand } from '../../components/layout/PageHeaderBand';
import { isFieldSurface } from '../../lib/inspection-surface';

/**
 * The page chrome for trip-inspection screens, by the tree they are opened in.
 *
 * Office (AppLayout): the gold-standard band, no stat strip.
 * Field (/field/*, the drivers' tree): the casing field header and back arrow
 * (FieldPageChrome, fe#815). The header carries the status-bar inset.
 */
export default function TripPageChrome({ title, eyebrow, onBack, children }: {
  title: string;
  eyebrow: string;
  onBack: () => void;
  children: React.ReactNode;
}) {
  const { pathname } = useLocation();
  if (isFieldSurface(pathname)) {
    return (
      <FieldPageChrome title={title} onBack={onBack}>
        {children}
      </FieldPageChrome>
    );
  }
  return (
    <div className="animate-fade-in min-h-full bg-fieldiq-dark">
      <PageHeaderBand eyebrow={eyebrow} title={title} onBack={onBack} backLabel="Back" />
      <section className="px-[var(--fi-page-inline)] py-[var(--fi-page-block)] pb-[var(--bottom-chrome)]">
        <div className="mx-auto max-w-[1920px]">{children}</div>
      </section>
    </div>
  );
}
